<template>
  <div>
    <DataLoader :is_on="updating"/>
    <div v-if="isActive" class="notifications-wrapper">
      <div class="notifications-elements-wrapper">
        <div
          v-for="(task, key) in tasks"
          :key="key"
          :class="['kalendar-notifikacija', 'task-'+task.event_type.class_colour]"
        >
          <div class="kalendar-notif-ikona">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="66"
              height="66"
              viewBox="0 0 66 66"
            >
              <g>
                <g>
                  <path
                    fill="#feedf3"
                    d="M33 0c18.225 0 33 14.775 33 33S51.225 66 33 66 0 51.225 0 33 14.775 0 33 0z"
                  />
                </g>
                <g>
                  <path
                    class="kalendar-icon"
                    fill="#fd4087"
                    d="M46.632 23.472v18.95a3.238 3.238 0 0 1-3.238 3.231H22.238A3.238 3.238 0 0 1 19 42.423V23.472a3.238 3.238 0 0 1 3.238-3.23h1.295v-2.154h2.16v2.153H39.94v-2.153h2.159v2.153h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H21.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H42.1v2.154h-2.16v-2.154H25.693v2.154h-2.159v-2.154h-1.295a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM23.102 30.47h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm-12.952 4.307h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="kalendar-notif-info">
            <div :class="'vrsta-eventa event-' + task.event_type.class_colour">
              {{ task.event_type.name }}
            </div>
            <div class="kalendar-notif-title" @click="openPopup(task)">{{ task.title }}</div>
            <div v-if="task.predmet != undefined">
              <div @click.stop="" v-if="can_i_see(task)" class="kalendar-event-case-name underline-item"><a :href="'/case/' + task.case_id">{{  task.predmet.ime_predmeta.length > 50 ? task.predmet.ime_predmeta.slice(0,50)+'...' :  task.predmet.ime_predmeta }}</a></div>
              <div v-else class="kalendar-event-case-name">
                {{ task.predmet.ime_predmeta.length > 50 ? task.predmet.ime_predmeta.slice(0,50)+'...' :  task.predmet.ime_predmeta }}
              </div>
            </div>
            <div v-else-if="task.project != undefined">
              <div @click.stop="" v-if="can_i_see(task)" class="kalendar-event-case-name underline-item"><a :href="'/projects/' + task.project_id">{{  task.project.name .length > 50 ? task.project.name.slice(0,50)+'...' :  task.project.name  }}</a></div>
              <div v-else class="kalendar-event-case-name">
                {{ task.project.name .length > 50 ? task.project.name.slice(0,50)+'...' :  task.project.name }}
              </div>
            </div>
            <div class="vrijeme-lokacija-event">
              <div class="datum-event" v-if="task.start_date_time != undefined && task.start_date_time != null">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14.3595 2.42254L14.3604 3.07846C16.7707 3.26737 18.3629 4.90979 18.3655 7.42853L18.375 14.8011C18.3784 17.5472 16.6532 19.2369 13.8878 19.2412L7.1329 19.25C4.38479 19.2535 2.63796 17.5236 2.63451 14.7696L2.62501 7.48363C2.62155 4.94828 4.15759 3.31022 6.5679 3.08896L6.56704 2.43303C6.56617 2.04823 6.85126 1.75875 7.23138 1.75875C7.61151 1.75787 7.8966 2.04648 7.89746 2.43129L7.89832 3.04348L13.03 3.03648L13.0291 2.42429C13.0282 2.03948 13.3133 1.75088 13.6934 1.75C14.0649 1.74913 14.3587 2.03773 14.3595 2.42254ZM3.95629 7.75387L17.0359 7.73638V7.43028C16.9988 5.54997 16.0554 4.56347 14.3621 4.41654L14.363 5.08995C14.363 5.46602 14.0701 5.76424 13.6986 5.76424C13.3185 5.76512 13.0326 5.46776 13.0326 5.0917L13.0317 4.38331L7.90005 4.3903L7.90091 5.09782C7.90091 5.47476 7.61669 5.77211 7.23657 5.77211C6.85645 5.77299 6.57049 5.47651 6.57049 5.09957L6.56963 4.42616C4.885 4.59495 3.95284 5.58496 3.95543 7.48188L3.95629 7.75387ZM13.3349 11.7288V11.7384C13.3436 12.1407 13.6718 12.4459 14.0701 12.4371C14.4589 12.4275 14.769 12.0943 14.7604 11.692C14.7422 11.3072 14.4304 10.9932 14.0425 10.9941C13.6451 11.0029 13.3341 11.3265 13.3349 11.7288ZM14.0485 15.6555C13.6511 15.6468 13.3306 15.3153 13.3297 14.913C13.3211 14.5107 13.6399 14.1775 14.0373 14.1679H14.0459C14.452 14.1679 14.7811 14.4994 14.7811 14.9104C14.782 15.3215 14.4537 15.6547 14.0485 15.6555ZM9.7756 11.7427C9.79288 12.145 10.122 12.459 10.5194 12.4415C10.9082 12.4232 11.2183 12.0908 11.2011 11.6885C11.1916 11.295 10.8719 10.9889 10.4831 10.9897C10.0857 11.0072 9.77474 11.3404 9.7756 11.7427ZM10.5229 15.6162C10.1255 15.6337 9.7972 15.3197 9.77906 14.9174C9.77906 14.5151 10.0892 14.1828 10.4866 14.1644C10.8754 14.1635 11.1959 14.4696 11.2045 14.8623C11.2227 15.2655 10.9116 15.5978 10.5229 15.6162ZM6.21629 11.7734C6.23357 12.1757 6.56272 12.4905 6.96012 12.4721C7.34888 12.4546 7.65902 12.1214 7.64088 11.7191C7.63224 11.3256 7.31259 11.0195 6.92297 11.0204C6.52557 11.0379 6.21542 11.3711 6.21629 11.7734ZM6.96357 15.6206C6.56617 15.6389 6.23788 15.3241 6.21974 14.9218C6.21888 14.5195 6.52989 14.1863 6.92729 14.1688C7.31605 14.1679 7.63656 14.474 7.6452 14.8676C7.66334 15.2699 7.35319 15.6031 6.96357 15.6206Z"
                    fill="#55556A" />
                </svg>
                {{ getDate(task.start_date_time) }}
              </div>
              <div class="vrijeme-event" v-if="task.event_type.uid == 2 || task.event_type.uid == 3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                >
                  <g>
                    <g>
                      <path
                        fill="#606076"
                        d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                      />
                    </g>
                  </g>
                </svg>
                <div v-if="
                    task.start_date_time != task.end_date_time
                  ">
                    {{ getSatiEvent(task.start_date_time) }} -
                    {{ getSatiEvent(task.end_date_time) }}
                </div>
                <div v-else>{{ getSatiEvent(task.start_date_time) }}</div>
              </div>
              <div v-if="task.location_address != null" class="lokacija-event">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                >
                  <g>
                    <g>
                      <path
                        fill="#606076"
                        d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z"
                      />
                    </g>
                  </g>
                </svg>
                  <v-tooltip v-if="task.location_address.length >= 25" right>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ task.location_address.slice(0, 25) }}...
                      </div>
                    </template>
                    <div class="flex-row">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="20"
                        viewBox="0 0 17 20"
                      >
                        <g>
                          <g>
                            <path
                              fill="#544EAC"
                              d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z"
                            />
                          </g>
                        </g>
                      </svg>
                      {{ task.location_address }}
                    </div>
                  </v-tooltip>
                  <div v-else>{{ task.location_address }}</div>
              </div>
            </div>
              <div
                v-if="
                  task.location_name != '' &&
                  task.location_name != null
                "
                class="event-opis-location"
              >
                {{ task.location_name }}
              </div>
              <a v-if="task.is_online" class="event-opis-location"
                :href="task.meeting_url"
                target="_blank"
                style="text-decoration: underline">
                {{ task.meeting_url.length > 45 ? task.meeting_url.slice(0,45)+'...' : task.meeting_url}}
              </a>
              <div v-if="can_i_see(task)" class="izvrsi-button" @click="completeTask(task)">{{ $t('components.general.notification.resolved') }}</div>
            <div class="izvrsi" @click="popByKey(key)">x</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import moment from "moment"
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import DataLoader from '@/components/generalComponents/DataLoader'
export default {
  props: {
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components:{
    DataLoader
  },
  data() {
    return {
      tasks: [],
      updating:false,
    };
  },
  computed: {
    isActive() {
      return this.tasks.length > 0;
    },
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("first tasks", (data) => {
          this.tasks = [];
          this.tasks = JSON.parse(data);
        });
      }
    },
    $route (to, from){
        if(to != from){
          this.tasks=[];
        }
    },
    tasks : function()
    {
      if(this.tasks.length == 0)
      {
        this.$store.state.notifies_shown = false;
        this.closeBlur()
      }
      else{
        this.$store.state.notifies_shown = true;
        this.activateBlur()
      }
    },
  },
  methods: {
    can_i_see(task) {
      console.log(task);
      return (task.event_lawyer_connector.find(p=> p.odvjetnik.uid == this.$store.state.logged_in_user.uid && !p.is_outside_member))
    },
    popByKey(key) {
      this.tasks.splice(key, 1);
    },
    closeBlur() {
      gsap.to(".router-wrapper", 0.5, { filter: "none", opacity:1 });
      gsap.to(".navigation", 0.5, { pointerEvents: "auto" });
    },
    activateBlur() {
      gsap.to(".router-wrapper", 0.5, { filter: "blur(5px)", opacity:0.2 });
      gsap.to(".navigation", 0.5, { pointerEvents: "none" });
    },
    openPopup(event) {
      // this.closeBlur();
      setTimeout(() => {
        this.$store.state.event_details.popup_open = true;
        this.$store.state.event_details.chosen_event = event;
        let tl = gsap.timeline();
        tl.to(".notifications-wrapper", 0.2, {
          opacity: 0
        });
        tl.to(".notifications-wrapper", 0, {
          display: "none"
        });
      }, 100);
      
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    getDate(date){
      return moment(date).format("DD.MM.yyyy.");
    },
    async completeTask(task){
      console.log(task);
      this.updating = true;
      await ms_calendar.editEventBucketStatus(task.uid, task.personal_event != undefined ?'personal' : 'case_event',0).then((resp)=>{
        this.updating = false;
        this.tasks = this.tasks.filter((ts)=>ts.uid != task.uid);
      }).catch((err)=>{});
    }
  },
  mounted() {
  },
};
</script>